import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hoverline",
  "use": "icon-hoverline-usage",
  "viewBox": "0 0 1 200",
  "content": "<symbol viewBox=\"0 0 1 200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hoverline\">\n<line x1=\"0.5\" y1=\"2.18557e-08\" x2=\"0.499991\" y2=\"200\" stroke=\"#1677FF\" stroke-dasharray=\"4 4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol